const INITIAL_STATE = {
    lastTextToVoice: '',
    lastTextToBot: '',
    lastVoiceToText: '',
    botStep: '',
    location: ''
};

export default function conversationReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'UPDATE_TEXT_TO_BOT_RESULT':
            return {
                ...state,
                lastTextToBot: action.result
            };
        case 'LOAD_TEXT_TO_BOT_RESULT':
            return {
                ...state,
                lastTextToBot: state.lastTextToBot,
            };
        case 'CLEAR_TEXT_TO_BOT_RESULT':
            return {
                ...state,
                lastTextToBot: INITIAL_STATE.lastTextToBot
            };
        case 'UPDATE_TEXT_TO_VOICE_RESULT':
            return {
                ...state,
                lastTextToVoice: action.result
            };
        case 'CLEAR_TEXT_TO_VOICE_RESULT':
            return {
                ...state,
                lastTextToVoice: INITIAL_STATE.lastTextToVoice
            };
        case 'UPDATE_VOICE_TO_TEXT_RESULT':
            return {
                ...state,
                lastVoiceToText: action.result
            };
        case 'CLEAR_VOICE_TO_TEXT_RESULT':
            return {
                ...state,
                lastVoiceToText: INITIAL_STATE.lastVoiceToText
            };
        case 'UPDATE_BOT_STEP':
            return {
                ...state,
                botStep: action.botStep
            };
        case 'UPDATE_LOCATION':
            return {
                ...state,
                location: action.location
            };
        default:
            return state;
    }
}
